import React from 'react';
import NotificationBar from './Common/NotificationBar';

import '../../static/scss/components/homeNotificationBar.scss';

const HomeNotificationBar = () => (
  <NotificationBar flag="home_banner" className="c-home-notification-bar" />
);
export default HomeNotificationBar;
